module.exports = {
          srcSet: __webpack_public_path__ + "d932476c631d7da8d292e5a461de8dca-470.png"+" 470w",
          images:[ {path: __webpack_public_path__ + "d932476c631d7da8d292e5a461de8dca-470.png",width: 470,height: 334}],
          src: __webpack_public_path__ + "d932476c631d7da8d292e5a461de8dca-470.png",
          toString:function(){return __webpack_public_path__ + "d932476c631d7da8d292e5a461de8dca-470.png"},
          
          width: 470,
          height: 334
        }